
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';

@Component({
  name: 'DateInput'
})
export default class DateInput extends Vue {
  @Prop()
  private value: string;

  @Prop()
  private id: string;

  @Prop({ default: '1970-01-01' })
  private min: string;

  @Prop({ default: '2999-12-31' })
  private max: string;

  private input = '';

  @Watch('value', { immediate: true })
  private onValueChange(newValue: string) {
    if (newValue) {
      this.input = newValue;
    } else {
      this.input = '';
    }
  }

  private handleFocus(e) {
    this.$emit('open');
  }

  private handleInput(e) {
    const d = new Date(e.target.value);

    if (d > new Date(this.max)) {
      this.input = this.max;
    } else if (d < new Date(this.min)) {
      this.input = this.min;
    } else {
      this.input = e.target.value;
    }

    this.$emit('input', this.input);
  }

  private handleBlur() {
    if (this.input !== this.value) {
      this.$emit('input', this.input);
    }

    this.$emit('close')
  }
}
